<div sdSpyTarget="footer">
  @if (!isSimplified) {
    <cx-page-slot position="ReinsuranceFooter" />
    <cx-page-slot position="NewsletterSocialFooter" />
    <cx-page-slot position="NavigationFooter" />
  }
  <cx-page-slot position="LegalFooter" />
</div>
